import { useDispatch, useSelector } from 'react-redux';

import { useEffect, useMemo } from 'react';

import { useQuery } from '@tanstack/react-query';

import { getFeatures } from '../../services/Feature/index';
import { RootState } from '../../store';
import { setFeaturesLoading, updateFeatures } from '../../store/featuresSlice';

export function useBootstrapFeatures() {
  const dispatch = useDispatch();
  const profile = useSelector((selector: RootState) => selector.profile.profileData);

  const enabled = useMemo(() => Boolean(profile), [profile]);

  const segmentsIds = useMemo(() => {
    const ids =
      profile?.TeacherClasses?.map(
        (teacherClass: { segmentId: number; classId: number }) =>
          teacherClass.segmentId,
      ).filter(Boolean) ?? [];

    return Array.from(new Set(ids)).join(',');
  }, [profile]);

  const { data, isLoading } = useQuery({
    queryKey: ['features', profile],
    queryFn: () => getFeatures(String(profile?.perfil.id), segmentsIds),
    enabled,
    staleTime: Infinity,
    retry: 0,
  });

  useEffect(() => {
    if (isLoading) {
      dispatch(setFeaturesLoading());
    }
  }, [isLoading]);

  useEffect(() => {
    if (data) {
      dispatch(updateFeatures(data));
    }
  }, [data]);

  return { data };
}
